// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import '../../App.css';
import Header from '../../components/Header.js';
import Progress from '../../components/Progress';

import Slider, { Range } from 'rc-slider';
import { Questions } from '../../assets/model';

type Props = {
  question: number,
  onChange: () => void,
  onNext: () => void
};

type State = {
  sliderValue: Array<number>,
  inputValue: Array<number>
};

class TypoOfChosenProperty extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      sliderValue: [],
      inputValue: []
    };
  }

  componentDidMount() {
    let { sliderValue, inputValue } = this.state;
    Questions[this.props.question].answers.forEach(answer => {
      sliderValue.push(answer.min);
      inputValue.push(answer.min);
    });
    this.setState({
      sliderValue,
      inputValue
    });
  }

  _handleSliderChange = (i, value, answer) => {
    value === '' ? '' : parseInt(value);
    let reduxAnswer = {
      answerPath: answer.answerPath,
      value
    };
    const { sliderValue, inputValue } = this.state;
    sliderValue[i] = value;
    inputValue[i] = value;
    this.setState({
      sliderValue,
      inputValue
    });
    this.props.onChange(this.props.question, reduxAnswer);
  };

  _handleInputChange = (i, value, answer) => {
    value === '' ? '' : parseInt(value);
    let reduxAnswer = {
      answerPath: answer.answerPath,
      value
    };
    const { sliderValue, inputValue } = this.state;
    inputValue[i] = value;

    this.setState({
      inputValue
    });
    this.props.onChange(this.props.question, reduxAnswer);
  };

  render(): React.Node {
    const { question } = this.props;

    return (
      <div className="main-transition-contianer">
        <div className="sliderContainer">
          {Questions[question].answers.map((answer, i) => {
            answer.step = answer.step || 1;
            return (
              <div key={i} className="slider">
                <div className="slider-label-container">
                  <span className="slider-label"> {answer.text} </span>
                  <div className="input-container">
                    <input
                      onChange={event => {
                        console.log('input change');
                        this._handleInputChange(i, event.target.value, answer);
                      }}
                      value={this.state.inputValue[i]}
                      type="text"
                      className="slider-input effect-2"
                    />
                    <span className="focus-border" />
                  </div>
                </div>
                <Slider
                  handleStyle={{
                    borderColor: '#70ac4b'
                  }}
                  trackStyle={{
                    backgroundColor: '#70ac4b'
                  }}
                  onChange={value => {
                    console.log('slider change');

                    this._handleSliderChange(i, value, answer);
                  }}
                  value={this.state.sliderValue[i]}
                  step={answer.step}
                  min={answer.min}
                  max={answer.max}
                />
              </div>
            );
          })}
        </div>
        <div className="bottomBar bottomBar--buttonRight">
          <div
            onClick={() => {
              this.props.onNext(Questions[question].answers[0].nextQuestion);
            }}
            className="button"
          >
            Weiter
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  state
}))(TypoOfChosenProperty);



// WEBPACK FOOTER //
// ./src/components/questions/AmountOfSpace.js